import { ListAccountsReq } from "gen/api/accounting/service_pb"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useListAccountsQuery } from "features/api/accounting"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export const accountFilterKey = "accounts"

export function useAccountFilter({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<UseWebFilterProps<unknown>, "persistInUrl" | "initialSelectedOptions">
> = {}) {
  const { data } = useListAccountsQuery(ListAccountsReq.create())

  const { filter, selected: selectedAccountIds } = useIdFilter({
    key: accountFilterKey,
    label: "GL account",
    values: data?.accounts ?? [],
    sort: (a, b) => a.name.localeCompare(b.name),
    labelExtractor: (account) => `${account.number} - ${account.name}`,
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })

  return { filter, selectedAccountIds }
}
